import { render } from "./TrialBalance.vue?vue&type=template&id=5ba6a55c&scoped=true"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"

import "./TrialBalance.vue?vue&type=style&index=0&id=5ba6a55c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba6a55c"]])

export default __exports__